<!-- enables to download and preview image and pdf document-->
<template>
  <div>
    <div class="file-card">
      <div class="file-card-header">
        <div class="file-icon">
          <b-icon icon="file-earmark" class="h3" aria-hidden="true"></b-icon>
        </div>
        <div class="file-title">{{ title }}</div>
        <div class="view-button">
          <b-icon
            icon="eye"
            class="h5 m-2 view-icon"
            aria-hidden="true"
            @click="viewFile"
          ></b-icon>
          <b-icon
            icon="download"
            class="h5 m-2 view-icon"
            aria-hidden="true"
            @click="downloadFile"
          ></b-icon>
        </div>
      </div>
    </div>
    <file-view-modal
      v-if="modalUrl"
      :url.sync="modalUrl"
      :key="modalUrl"
      :axios="selectedAxios"
      :modalId="id"
      :title="modalTitle"
    />
  </div>
</template>
<script>
import FileViewModal from "../../Common/_components/file-view-modal.vue";
import applicantAxios from "../_utils/axios";
import config from "../../../config";
import axios from "axios";

export default {
  props: {
    title: String,
    id: String,
    documentUrl: String,
    isApplicant: Boolean,
  },
  data() {
    return {
      config,
      applicantAxios,
      modalUrl: null,
      modalTitle: "",
      axios,
    };
  },
  components: {
    "file-view-modal": FileViewModal,
  },
  computed: {
    selectedAxios() {
      return this.isApplicant ? applicantAxios : axios;
    },
    fileUrl() {
      if (!this.documentUrl) return null;
      const basePath = this.isApplicant
        ? "/applicant-master/joining-form/files/"
        : "/applicants/joining-form/files/";

      return `${this.config.ROOT_API}${basePath}?FileId=${encodeURIComponent(
        this.documentUrl
      )}`;
    },
  },
  methods: {
    viewFile() {
      this.modalTitle = this.title;
      this.modalUrl = this.fileUrl + "&t=" + Date.now();
      this.$nextTick(() => {
        const sel = `#${this.id}`;
        const active = document.activeElement;
        if ($(sel)[0]?.contains(active)) {
          active.blur();
        }
        $(sel).modal("hide").modal("show");
      });
    },
    async fetchDocumentAsBlob(url) {
      try {
        const response = this.isApplicant
          ? await applicantAxios.get(url)
          : await axios.get(url);
        const fileType = response.data.mimeType;

        let blob;
        if (typeof response.data.fileData === "string") {
          const base64Data = response.data.fileData.replace(
            /^data:.+;base64,/,
            ""
          );
          // Convert base64 string to Uint8Array
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          blob = new Blob([byteArray], { type: fileType });
        }

        return {
          blob,
          fileType,
        };
      } catch (error) {
        console.error("Error fetching document:", error);
        return null;
      }
    },

    async downloadFile() {
      try {
        const { blob } = await this.fetchDocumentAsBlob(this.fileUrl);
        if (blob) {
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          let extension = "";
          if (this.title === "Passport Photo") {
            extension = "jpg";
          } else {
            extension = "pdf";
          }

          // Use the title as the filename and include the appropriate extension
          const safeTitle = this.title.replace(/\s+/g, "_"); //removes spaces and replaces with underscores
          link.setAttribute(
            "download",
            `${safeTitle}${extension ? "." + extension : ""}`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(blobUrl);
          document.body.removeChild(link);
        } else {
          this.$store.dispatch("openSnackbar", {
            type: "danger",
            message: "Failed to download the document.",
          });
        }
      } catch (error) {
        console.error("Error in downloadFile:", error);
        this.$toast.error(".");
        this.$store.dispatch("openSnackbar", {
          type: "danger",
          message: "An error occurred while downloading the document.",
        });
      }
    },
  },
};
</script>

<style scoped>
@import "./tabStyles.css";
.file-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 12px;
  max-width: 400px;
}

.file-card-header {
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 12px;
}

.file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eef2f6;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

.file-title {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  flex-grow: 1;
}

.view-button {
  display: flex;
  align-items: center;
}

.view-icon {
  font-size: 1.2rem;
  color: #007bff;
  cursor: pointer;
  transition: color 0.3s ease;
}

.view-icon:hover {
  color: #0056b3;
}
</style>
